/* === Fix apertura foto corretta dopo cambio variante === */
document.addEventListener('DOMContentLoaded', function() {
  
  function getImageFilename(src) {
    if (!src) return null;
    return src.split('/').pop().split('?')[0];
  }

  function syncModalFirstSlide() {
    const modal = document.querySelector('product-modal');
    if (!modal) return;
    
    const firstGalleryItem = document.querySelector('.product__media-item.swiper-slide');
    if (!firstGalleryItem) return;
    
    const firstGalleryImg = firstGalleryItem.querySelector('img');
    if (!firstGalleryImg) return;

    const firstModalImg = modal.querySelector('.swiper-slide img');
    if (!firstModalImg) return;
    
    firstModalImg.src = firstGalleryImg.currentSrc || firstGalleryImg.src;
    firstModalImg.srcset = firstGalleryImg.srcset;
    firstModalImg.sizes = '100vw';
  }

  // Ascolta cambio variante
  document.addEventListener('change', function(e) {
    if (e.target.closest('.product-form, variant-radios, variant-selects')) {
      setTimeout(syncModalFirstSlide, 300);
    }
  });

  document.addEventListener('click', function(e) {
    const opener = e.target.closest('.product__modal-opener--image, .product__media-toggle');
    if (!opener) return;
    
    const mediaItem = opener.closest('.product__media-item.swiper-slide');
    if (!mediaItem) return;
    
    const img = mediaItem.querySelector('img');
    const filename = getImageFilename(img?.src);
    if (!filename) return;
    
    const modal = document.querySelector('product-modal');
    if (!modal) return;
    
    modal.style.opacity = '0';
    
    setTimeout(function() {
      modal.style.opacity = '1';
      
      const swiper = modal.querySelector('.swiper')?.swiper;
      if (!swiper) return;
      
      const modalSlides = [...modal.querySelectorAll('.swiper-slide')];
      const slideIndex = modalSlides.findIndex(slide => {
        const slideImg = slide.querySelector('img');
        return getImageFilename(slideImg?.src) === filename;
      });
      
      if (slideIndex !== -1) {
        swiper.slideTo(slideIndex, 0);
      } else {
        swiper.slideTo(0, 0);
      }
    }, 50);
  });
});